import React, { createContext, useContext } from 'react';
import logo from './logo.svg';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

// Import your components
import { AuthCheck } from './components/auth/AuthCheck';
import { HomePage } from './pages/HomePage';
import NavBar from './pages/NavBarPage';
import VirtualAssistantsList from './pages/virtualassistanthome/VirtualAssistantsList';
import BuildNewAssistant from './pages/BuildNewAssistant';
import { Footer } from './pages/FooterPage';
import UnauthorizedMessage from './components/auth/UnauthorizedMessage';
// Create context for role functionalities
interface RoleFunctionality {
  Functionality: string;
  Role: string;
  ScreenName: string;
}

interface AuthContextType {
  roleFunctionalities: RoleFunctionality[];
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Hook to check for specific functionality
const useHasFunctionality = (functionality: string) => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useHasFunctionality must be used within AuthContext');
  
  return context.roleFunctionalities.some(
    rf => rf.Functionality === functionality
  );
};

// Protected content component
const ProtectedContent = ({ children }: { children: React.ReactNode }) => {
  const hasHomeScreen = useHasFunctionality('HomeScreen');

  if (!hasHomeScreen) {
    return <UnauthorizedMessage />;
  }

  return (
    <div>
      <div id="wrapper">
        <NavBar />
        <main className="ml-8 p-4 w-full ">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthCheck
      children={(authContext) => (
        <AuthContext.Provider value={authContext}>
          <Router> {/* Wrap everything inside Router */}
            <Routes>
              <Route path="/" element={<ProtectedContent><VirtualAssistantsList /></ProtectedContent>} />
              {/* Define route for Build New Assistant */}
              <Route path="/buildNewAssistant" element={<ProtectedContent><BuildNewAssistant /></ProtectedContent>} />
              {/* Define route for accessing VA directly by ID */}
              <Route path="/va/:appId" element={<ProtectedContent><BuildNewAssistant /></ProtectedContent>} />
            </Routes>
          </Router>
        </AuthContext.Provider>
      )}
    />
  );
}

export default App;